import React from "react";
/**
 * Render the footer of the calendar.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
export function Footer(props) {
    return React.createElement("div", { ...props });
}
//# sourceMappingURL=Footer.js.map